module.exports = __webpack_public_path__ + "img/exp-date-error.72ee4595.svg";